import React from "react";
import { Container } from "react-bootstrap";
import NotificationCenter from "../../components/notifications/NotificationCenter";
import InViewFadeUp from "../../components/animations/InViewFadeUp";
import { useAuth } from "../../contexts/AuthContext";

const NotificationsPage = ({ selectedClient, onClose }) => {
  const { user, isAuthenticated } = useAuth();
  
  return (
    <Container fluid className="py-4">
      <InViewFadeUp delay={0.1}>
        <NotificationCenter 
          selectedClient={selectedClient} 
          onClose={onClose}
          currentUser={{ ...user, is_authenticated: isAuthenticated }}
        />
      </InViewFadeUp>
    </Container>
  );
};

export default NotificationsPage;
